import { Tenant } from '../hooks/useAppSwitcherDataTypes';

export const environmentToChipKey = (
  environment: string,
  tenantCategory?: string,
) => {
  if (tenantCategory === 'DEVELOPER') {
    return 'dsbx';
  }

  return environment.includes('SANDBOX')
    ? 'sbx'
    : environment.includes('ZUORA')
    ? 'prod'
    : environment.includes('CENTRAL')
    ? 'csbx'
    : environment.includes('STAGING')
    ? 'stg'
    : environment.includes('PREPROD')
    ? 'preprod'
    : undefined;
};

const collectAllNodeIds = (nodes: Tenant[] = []): string[] => {
  return nodes.reduce<string[]>((acc, node) => {
    if (node.id) acc.push(node.id);
    acc.push(...collectAllNodeIds(node.children));
    return acc;
  }, []);
};

const ListToTree = (tenants: Tenant[]): Tenant[] => {
  const rootTenants: Tenant[] = [];

  const adjustedTenants: Tenant[] = tenants.map((tenant) => ({
    ...tenant,
    environment: tenant.environment
      ? environmentToChipKey(tenant.environment, tenant.tenantCategory)
      : undefined,
    children: [],
  }));

  const tenantsMap = adjustedTenants.reduce((acc, tenant) => {
    return { ...acc, ...(tenant.id && { [tenant.id]: tenant }) };
  }, {});

  adjustedTenants.forEach((tenant) => {
    const isBillingRevenue = Boolean(
      tenant.linkedBillingZuoraTenantId &&
        tenantsMap[tenant.linkedBillingZuoraTenantId],
    );
    const isBillingBilling =
      tenant.entities?.[0]?.rootTenantId &&
      tenant.entities[0].rootTenantId !== tenant.id &&
      tenantsMap[tenant.entities[0].rootTenantId];

    if (isBillingRevenue) {
      const parentTenant =
        tenantsMap[
          tenant.linkedBillingZuoraTenantId
            ? tenant.linkedBillingZuoraTenantId
            : ''
        ];
      parentTenant.children.push(tenant);
    } else if (isBillingBilling) {
      const parentTenant =
        tenantsMap[
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          tenant.entities![0].rootTenantId
            ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              tenant.entities![0].rootTenantId
            : ''
        ];
      parentTenant.children.push(tenant);
    } else {
      rootTenants.push(tenant);
    }
  });

  return rootTenants;
};

const useAppSwitcherTree = (tenants: Tenant[]) => {
  const tree = ListToTree(tenants);
  const allNodeIds = collectAllNodeIds(tree);
  return { tree, allNodeIds };
};

export default useAppSwitcherTree;
